export enum CMS_TYPE {
  JIRA = 'jira',
  ZENDESK = 'zendesk',
  SERVICE_NOW = 'servicenow',
  REMEDY = 'remedy',
  SALES_FORCE = 'salesforce',
}
